<template>
  <div class="lv-pick-guideline">
    <LvText
      v-if="title"
      h6
      bold
    >
      {{ $t(title) }}
    </LvText>
    <WsButton001
      class="mt-8"
      @click="$_onOpenPopup('popup')"
    >
      {{ $t(btnText) }}
    </WsButton001>
    <LvFlexBox v-if="value && value.length > 0">
      <WsButton001
        v-for="(item, itemIndex) in value"
        :key="itemIndex"
        outLine
        flatButton
        nonMinWidth
        trailingIcon="icon-cancel"
        class="mt-4 mr-4"
        @click-content="$_onClickRelatedGuideline(item)"
        @click-trailing-icon="$_onRemoveItem(item)"
      >
        {{ $_getItemName(item)}}
      </WsButton001>
    </LvFlexBox>
    <PopUp
      v-if="isActive.popup"
      ref="LvPickGuidelinePopup"
      bottom
      title="相關內規"
      :clickOutsideClose="false"
      :popUpActive="isActive.popup"
      :hasMoreContent="relateGuidelineType.value === 'article' && paginate.ingPage < paginate.lastPage"
      @scroll="$_onScroll"
      @click="$_onClosePopup('popup')"
    >
      <div v-show="ingStep === 0">
        <LvDataTable
          filterZIndex="221"
          :fetchUrl="_fetchUrl"
          :setParams="$_setParams"
          :setListData="$_setListData"
          :columnHeader="columnHeader.guideline"
          :filterFieldTypes="filterFieldTypes"
          @data-click="$_onSelectItem"
          @page-change="$_onPageChange"
        />
      </div>
      <div v-if="ingStep === 1">
        <WsTitle001 h6 bold class="mb-8 mt-20">
          {{ $t('名稱') }}
        </WsTitle001>
        <WsText001 h6 class="mb-20">
          {{ _selectedGuidelineName }}
        </WsText001>
        <LvStateRadioBtn
          :value="versionMode.value"
          required
          isNarrow
          title="關聯版本設定"
          :state="versionMode.value"
          :radioButtonItem="versionMode.radioButtonItem"
          class="mb-20 h5"
          @input="$_onSelectVersionMode"
        />
        <WsRow v-if="versionMode.value === 'version'" class="mb-8">
          <WsCol cols="3" smcols="12">
            <DropdownMenuButton
              outline
              title="選擇版本"
              :value="versionList.selectedItem"
              :isLoading="isLoading.versionList"
              :dropdownMenuItem="versionList.items"
              :style="{'z-index': '221'}"
              @input="$_onSelectVersion"
            />
          </WsCol>
        </WsRow>
        <LvStateRadioBtn
          :value="relateGuidelineType.value"
          required
          isNarrow
          title="綁定種類"
          :state="relateGuidelineType.value"
          :radioButtonItem="relateGuidelineType.radioButtonItem"
          class="mb-20 h5"
          @input="$_onSelectRelateGuidelineType"
        />
        <LvText v-if="relateGuidelineType.value === 'article'" h6 bold class="mb-4">{{$t('已選擇')}}</LvText>
        <LvText v-if="relateGuidelineType.value === 'article' && !selectedArticleList.length" h6>{{ `(${$t('尚未選取內規或層級條文')})` }}</LvText>
        <LvFlexBox v-if="relateGuidelineType.value === 'article'" class="mb-20">
          <WsButton001
            v-for="(article, articleIndex) in selectedArticleList"
            :key="articleIndex"
            outLine
            nonMinWidth
            trailingIcon="icon-cancel"
            :style="{'min-height': '32px'}"
            class="mb-4 mr-4"
            @click="$_onRemoveSelectedArticle(article)"
          >
            {{ article.name }}
          </WsButton001>
        </LvFlexBox>
        <SearchInput
          v-if="relateGuidelineType.value === 'article'"
          :value="filterState.article.search"
          placeholder="搜尋"
          @input="$_resetAndGetArticleList"
        />
        <DotLoading v-if="relateGuidelineType.value === 'article' && isLoading.articleList && this.articleList.length === 0"/>
        <LvGuidelineLayer v-if="relateGuidelineType.value === 'article' && articleList.length > 0" :value="articleList" :isLoading="isLoading.article" class="mt-20">
          <template v-slot:content="{item}">
            <LvFlexBox noWrap class="mb-8">
              <LvCheckbox
                h4
                exclusive
                :value="true"
                :select="item.isChecked"
                :disable="item.checkboxDisable"
                :isParentSelected="item.isParentSelected"
                class="mr-8"
                @change="$_onCheckArticle($event, item)"
              />
              <LvText :lightGray="item.checkboxDisable" class="lv-pick-guideline__text" @click="$_onClickItem(item)">{{ item.name }}</LvText>
            </LvFlexBox>
          </template>
        </LvGuidelineLayer>
        <DotLoading v-if="relateGuidelineType.value === 'article' && isLoading.articleList && articleList.length > 0"/>
        <LlEmptyPic
          v-if="relateGuidelineType.value === 'article' && !isLoading.articleList && (!articleList || !articleList.length)"
          title="目前尚無資料"
          :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
        />
      </div>
      <template slot="bottomBtn">
        <WsButton001
          outLine
          @click="$_onClosePopup('popup')"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          v-if="ingStep === 1"
          outLine
          @click="$_onBackStep"
        >
          {{ $t('上一步') }}
        </WsButton001>
        <WsButton001
          v-if="ingStep === 1"
          class="mt-0"
          :disable="relateGuidelineType.value !== 'guideline' && !selectedArticleList.length"
          :isloading="isLoading.selectVersion || isLoading.selectVersionMode"
          @click="$_onSubmit"
        >
          {{ $t('送出') }}
        </WsButton001>
      </template>
    </PopUp>
    <LvPopupInfoArticle
      ref="LvPopupInfoArticle"
    />
  </div>
</template>

<script>
import S_guidelineVersion from '@/service/api/v1/guidelineVersion';
import S_guidelineArticleVersion from '@/service/api/v1/guidelineArticleVersion';
import H_guideline from '@/helpers/guideline';
import H_guidelineVersion from '@/helpers/guidelineVersion';
import H_guidelineArticleVersion from '@/helpers/guidelineArticleVersion';
import Spare_guideline from '@/spare/guideline';

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '相關內規',
    },
    btnText: {
      type: String,
      default: '選擇'
    },
  },
  data() {
    return{
      isLoading: {
        versionList: false,
        articleList: false,
        selectVersion: false,
        selectVersionMode: false,
      },
      isActive: {
        popup: false,
      },
      ingStep: 0,
      columnHeader: {
        guideline: Spare_guideline.columnHeader.filter(item => item.id !== 'isCollected'),
        article: [
          {
            id: 'isChecked',
            type: 'checkbox',
            tabletHide: false,
            width: '10px',
          },
          {
            id: 'name',
            textLabel: '名稱',
            type: 'text',
            tabletHide: false,
          },
        ],
      },
      filterFieldTypes: Spare_guideline.filterFieldTypeList,
      selectedGuideline: {},
      selectedArticleList: [],
      versionMode: {
        value: 'latest',
        radioButtonItem: {
          name: 'versionMode',
          buttonItems: [
            {
              id: 'latest',
              textLabel: '最新版本 (將來此內規有版本更新時，自動關聯至最新版本)',
            },
            {
              id: 'version',
              textLabel: '特定版本',
            },
          ],
        }
      },
      relateGuidelineType: {
        value: 'guideline',
        radioButtonItem: {
          name: 'relateGuidelineType',
          buttonItems: [
            {
              id: 'guideline',
              textLabel: '綁定整部內規',
            },
            {
              id: 'article',
              textLabel: '綁定層級或條文',
            },
          ],
        }
      },
      versionList: {
        selectedItem: '',
        items: [],
      },
      filterState: {
        article: {
          search: '',
        },
      },
      paginate: {
        ingPage: 1,
        lastPage: 1,
      },
      articleList: [],
      guidelineVersionData: {},
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factory.id;
    },
    _fetchUrl() {
      return `factory/${this._currentFactoryId}/guideline`;
    },
    _selectGuidelineVerId() {
      return this.versionMode.value === 'latest'
        ? this.selectedGuideline.versionId
        : this.versionList.selectedItem;
    },
    _selectedGuidelineName() {
      const selectedGuidelineName = this.selectedGuideline && this.selectedGuideline.name
        ? this.selectedGuideline.name.text
        : '';
      if (this.versionMode.value === 'latest') return selectedGuidelineName;
      return this.guidelineVersionData && Object.keys(this.guidelineVersionData).length !== 0
        ? this.guidelineVersionData.name
        : selectedGuidelineName;
    },
  },
  methods: {
    $_setParams(filterState) {
      return H_guideline.setIndexParams(filterState);
    },
    $_setListData(rawDataList) {
      return H_guideline.setIndex(rawDataList);
    },
    $_onSelectItem($event) {
      this.selectedGuideline = $event;
      this.ingStep ++;
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
      const actionList = {
        'popup': () => {
          this.ingStep = 0;
        },
      };
      if (actionList[type]) actionList[type]();
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
      const actionList = {
        'popup': () => {
          this.ingStep = 0;
          this.$_onReset();
        },
      };
      if (actionList[type]) actionList[type]();
    },
    async $_onScroll() {
      if (this.ingStep !== 1 || this.isLoading.articleList || this.paginate.ingPage === this.paginate.lastPage || this.relateGuidelineType.value !== 'article' ) return;
      this.paginate.ingPage ++;
      await this.$_getArticleList(true);
    },
    $_onSubmit() {
      const { value: versionMode } = this.versionMode;
      const { value: relatedType } = this.relateGuidelineType;
      const {id: guidelineId} = this.selectedGuideline;
      const selectedVersion = this.versionList.items.find(item => item.id === this.versionList.selectedItem);
      const baseData = {
        type: 'guideline',
        name: `${this._selectedGuidelineName} ${versionMode === 'version' ? `(${selectedVersion.textLabel})` : '(Latest)'}`,
        guideline_id: guidelineId,
        ...(versionMode === 'version' && { guideline_version_id: this._selectGuidelineVerId }),
      };
      const selectedList = relatedType === 'guideline'
        ? [baseData]
        : this.selectedArticleList.map(item => {
            const {id, articleId} = item;
            return {
              ...baseData,
              ...item,
              articleVerId: id,
              guideline_article_id: articleId,
              guideline_version_id: this._selectGuidelineVerId,
              ...(versionMode === 'version' && { guideline_article_version_id: id })
            };
          });
      this.$emit('input', this.$_removeDuplicate(this.value, selectedList));
      this.$_onClosePopup('popup');
    },
    $_removeDuplicate(value, selectedList) {
      const result = [...value];
      selectedList.forEach(item => {
        if (!this.$_isDuplicate(result, item)) result.push(item);
      })
      return result;
    },
    $_isDuplicate(result, examItem) {
      const { type, guideline_version_id, guideline_id, guideline_article_version_id, guideline_article_id} = examItem;
      if (type === 'guideline') {
        if (guideline_version_id) {
          return result.some(resultItem => resultItem.guideline_version_id === guideline_version_id);
        } else {
          return result.some(resultItem => !resultItem.guideline_version_id && resultItem.guideline_id === guideline_id);
        }
      } else if (type === 'article' || type === 'title') {
        if (guideline_article_version_id) {
          return result.some(resultItem => resultItem.guideline_article_version_id === guideline_article_version_id);
        } else {
          return result.some(resultItem => !resultItem.guideline_article_version_id && resultItem.guideline_article_id === guideline_article_id);
        }
      } else {
        return false;
      }
    },
    $_onBackStep() {
      this.ingStep --;
      this.$_onReset();
    },
    $_onReset() {
      this.selectedGuideline = {};
      this.versionMode.value = 'latest';
      this.relateGuidelineType.value = 'guideline';
      this.filterState.article.search = '';
      this.articleList = [];
      this.paginate.ingPage = 1;
      this.selectedArticleList = [];
    },
    async $_getVersionList(guidelineId) {
      this.isLoading.versionList = true;
      const res = await S_guidelineVersion.indexAnnounce(guidelineId);
      this.isLoading.versionList = false;
      return H_guidelineVersion.setDropdown(res, this._versionId);
    },
    async $_onSelectVersion(versionId) {
      if (this.versionList.selectedItem === versionId) return;
      this.versionList.selectedItem = versionId;
      this.isLoading.selectVersion = true;
      this.guidelineVersionData = await this.$_getGuidelineVersionData(versionId);
      this.isLoading.selectVersion = false;
      if (this.relateGuidelineType.value === 'article') {
        await this.$_resetAndGetArticleList();
      }
    },
    async $_getArticleList(isScroll = false) {
      this.isLoading.articleList = true;
      const params = {
        page: this.paginate.ingPage,
        search: this.filterState.article.search,
      };
      const {data, meta} = await S_guidelineArticleVersion.indexByGuidelineVersion(this._selectGuidelineVerId, params);
      this.articleList = isScroll
        ? [...this.articleList, ...H_guidelineArticleVersion.setPickGuidelineList(data, this.selectedArticleList)]
        : H_guidelineArticleVersion.setPickGuidelineList(data, this.selectedArticleList);
      this.paginate = {
        lastPage: meta.last_page,
        ingPage: meta.current_page,
      };
      this.isLoading.articleList = false;
    },
    async $_resetAndGetArticleList(search = '') {
      this.articleList = [];
      this.paginate.ingPage = 1;
      this.filterState.article.search = search;
      await this.$_getArticleList();
    },
    async $_onSelectVersionMode(versionMode) {
      this.isLoading.selectVersionMode = true;
      this.versionMode.value = versionMode;
      this.selectedArticleList = [];
      if (this.relateGuidelineType.value === 'article') {
        this.articleList = [];
        this.isLoading.articleList = true;
      }
      if (versionMode === 'version' && this.selectedGuideline && this.selectedGuideline.id) {
        this.versionList = await this.$_getVersionList(this.selectedGuideline.id);
        this.guidelineVersionData = await this.$_getGuidelineVersionData(this.versionList.selectedItem);
      } else {
        this.guidelineVersionData = {};
      }
      this.isLoading.selectVersionMode = false;
      if (this.relateGuidelineType.value === 'article') {
        this.paginate.ingPage = 1;
        await this.$_getArticleList();
      }
    },
    async $_onSelectRelateGuidelineType(relateGuidelineType) {
      this.relateGuidelineType.value = relateGuidelineType;
      if (relateGuidelineType === 'article') {
        await this.$_resetAndGetArticleList();
      }
    },
    $_onCheckArticle($event, item) {
      const isChecked = $event;
      const tarArticle = this.articleList.find(article => article.id === item.id);
      if (isChecked) {
        this.selectedArticleList.push({
          ...item,
          guidelineName: this._selectedGuidelineName,
        });
        if (tarArticle) {
          tarArticle.isChecked = true;
          this.$_isCheckboxDisable(item.id, true);
        }
      } else {
        this.selectedArticleList = this.selectedArticleList.filter(article => article.id !== item.id);
        if (tarArticle) {
          tarArticle.isChecked = false;
          this.$_isCheckboxDisable(item.id, false);
        }
      }
    },
    $_isCheckboxDisable(disableParentId, disable) {
      const examArticleList = this.articleList.filter(item => item.parentId === disableParentId);
      examArticleList.forEach(item => {
        item.checkboxDisable = disable;
        item.isParentSelected = disable;
        if (disable && item.isChecked) {
          item.isChecked = false;
          this.selectedArticleList = this.selectedArticleList.filter(article => article.id !== item.id);
        }
        this.$_isCheckboxDisable(item.id, disable);
      });
    },
    $_onRemoveSelectedArticle(article) {
      const {id} = article;
      this.selectedArticleList = this.selectedArticleList.filter(item => item.id !== id);
      const tarArticle = this.articleList.find(item => item.id === id);
      if (!tarArticle) return;
      tarArticle.isChecked = false;
      this.$_isCheckboxDisable(id, false);
    },
    async $_onClickItem($event) {
      const {type, id} = $event;
      const actionList = {
        'title': () => {
          const query = {
            articleVerId: id,
          };
          if (this.versionMode.value === 'version') {
            query.versionId = this.versionList.selectedItem;
          }
          const url = this.$router.resolve({
            path: `/factory/${this._currentFactoryId}/guideline-content/${this.selectedGuideline.id}`,
            query,
          });
          window.open(url.href, '_blank');
        },
        'article': async (article) => {
          this.$refs.LvPopupInfoArticle.$_onOpenPopup({
            ...article,
            name: `${this._selectedGuidelineName} ${article.name}`
          });
        },
      };
      if (actionList[type]) await actionList[type]($event);
    },
    $_onRemoveItem(item) {
      const value = [...this.value];
      let resultArr = [];
      const keys = [
        'guideline_article_version_id',
        'guideline_article_id',
        'guideline_version_id',
        'guideline_id',
      ];
      for (const [keyIndex, key] of keys.entries()) {
        if (item[key]) {
          resultArr = value.filter(_value => {
            const isValid = keys.slice(0, keyIndex).every(prevKey => !_value[prevKey]);
            if (isValid && _value[key]) return _value[key] !== item[key];
            else return _value;
          });
          break;
        }
      }
      this.$emit('input', resultArr);
    },
    async $_onClickRelatedGuideline($event) {
      const {
        type,
        guideline_id: guidelineId,
        guideline_version_id: guidelineVerId,
        articleVerId,
        name,
        guidelineName,
      } = $event;
      if (type === 'guideline' || type === 'title') {
        const query = {};
        if (type === 'title') query.articleVerId = articleVerId;
        if (guidelineVerId) query.versionId = guidelineVerId;
        const url = this.$router.resolve({
          path: `/factory/${this._currentFactoryId}/guideline-content/${guidelineId}`,
          query,
        });
        window.open(url.href, '_blank');
      } else if (type === 'article') {
        this.$refs.LvPopupInfoArticle.$_onOpenPopup({
          ...$event,
          name: `${guidelineName} ${name}`,
        });
      }
    },
    async $_getGuidelineVersionData(versionId) {
      if ( versionId === this.selectedGuideline.versionId) {
        const {versionId: id, name} = this.selectedGuideline;
        return {
          id,
          name: name.text,
        };
      } else {
        const rawVersionData = await S_guidelineVersion.show(versionId);
        return H_guidelineVersion.setShow(rawVersionData);
      }
    },
    $_getItemName(item) {
      return item.type === 'guideline'
        ? item.name
        : item.guideline_article_version_id
        ? `${item.name} (${item.announceAt})`
        : `${item.name} (Latest)`;
    },
    $_onPageChange() {
      if (!this.$refs.LvPickGuidelinePopup) return;
      this.$refs.LvPickGuidelinePopup.$refs.perfectScrollbar.$el.scrollTop = 0;
    }
  },
};
</script>